import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DebtorAccountHistoryWidgetSequenceSelectionComponent } from './components/sequence-selection/debtor-account-history-widget-sequence-selection.component';
import { RadioButtonModule } from "primeng/radiobutton";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    DebtorAccountHistoryWidgetSequenceSelectionComponent,
  ],
  exports: [
    DebtorAccountHistoryWidgetSequenceSelectionComponent,
    DropdownModule,
    RadioButtonModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    RadioButtonModule,
  ],
  providers: []
})
export class DebtorAccountHistoryWidgetSelectionComponentModule { }
